import { MAIN_SITE_HOMEPAGE } from 'config';
import { produce } from 'immer';
import { memoize, noop } from 'lodash-es';
import React from 'react';
import { Theme } from 'theme';

export const footerClickHandlers = {
  handlePhoneContactClick: noop,
  handleMailClick: noop,
  handleOpenChatClick: (showChat: () => void) => showChat(),
  handleOpenFAQClick: (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    window.open(`${MAIN_SITE_HOMEPAGE}faq`);
  },
} as const;

export const FooterMenuTheme: (globalTheme: Theme) => Theme = memoize(
  (globalTheme) =>
    produce(globalTheme, (draft) => {
      draft.footer.container.selfMarginHandling = false;
      draft.footer.container.borderRadius = 'none';
    }),
);
